import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AsyncAjaxGet } from 'components/AsyncAjaxServiceV2';
import { utils } from 'vagaro-website-rendering/src/utils/Utils';
import { resolveReleaseFlags } from 'vagaro-website-rendering/src/utils/ResolveReleaseFlags';
import { Site } from 'Utils/Utils';


let BusinessData = [];
const VagaroAPIEnum = {
    businessMultilocation: "businesslogincustomerdetails/businesslocationasync"
};
export const BusinessLocation = createAsyncThunk(
    'GetBusinessLocation',
    async (Requestdata, thunkApi) => {
        let LoginDetails = utils.ReadCookie();
        let vwbencmerchantID = document.getElementById('vwbencmerchantID');
        let encmerchantID = vwbencmerchantID ? vwbencmerchantID.value : null;

        let LoginUserId = LoginDetails === undefined || LoginDetails === "" || LoginDetails === null ? "" : LoginDetails.cEncUid === undefined || LoginDetails.cEncUid === null || LoginDetails.cEncUid === "" ? "" : LoginDetails.cEncUid;
        await AsyncAjaxGet(
            VagaroAPIEnum.businessMultilocation + "?" + (Requestdata.VGURL != "" ? ("SiteName=&VagaroURL=" + Requestdata.VGURL) + "&UserId=" + LoginUserId + (encmerchantID != undefined && encmerchantID != null && encmerchantID != "" ? "&EncMerchantID=" + encmerchantID : "") :
                ("SiteName=" + Requestdata.SiteName + "&VagaroURL=") + "&UserId=" + LoginUserId + (encmerchantID != undefined && encmerchantID != null && encmerchantID != "" ? "&EncMerchantID=" + encmerchantID : "")),
            Requestdata.access_token,
            function onSuccess(data) {
                if (data != null && data.data != null) {
                    BusinessData = data.data.data;
                    if (typeof BusinessData != "undefined" && BusinessData != null && BusinessData != "" && BusinessData.length > 0) {
                        localStorage.setItem('VgBUrl', Requestdata.VGURL);

                        // Use the specific business record this page resolved to (matched by
                        // VGURL, same as the request itself) so the flag resolves against its
                        // real group/merchant instead of possibly-stale DOM/localStorage values.
                        // Falls back to resolveReleaseFlags' own DOM/localStorage lookup when no
                        // match is found (e.g. custom-domain requests, where VGURL is empty).
                        const currentBusiness = Requestdata.VGURL
                            ? BusinessData.find((b) => b?.vagaroURL?.toLowerCase() === Requestdata.VGURL.toLowerCase())
                            : null;
                        resolveReleaseFlags(Site.VagaroCoreApiUrl, currentBusiness
                            ? { merchantid: currentBusiness.staticEncBID, group: currentBusiness.group }
                            : undefined);
                    }
                    $(".wbloader").css("display", "none");
                }
                else {
                    return thunkApi.rejectWithValue([]);
                }
            },
            function OnError() {
                return thunkApi.rejectWithValue([]);
            }
        );
        return thunkApi.fulfillWithValue(BusinessData);
    }
)

export const BusinessLocationSlice = createSlice({
    name: 'BusinessLocation',
    initialState: {
        data: [],
        isCompletedLocationCall: false
    },
    extraReducers: {
        [BusinessLocation.fulfilled]: (state, action) => {
            if (typeof action.payload !== undefined && action.payload !== null) {
                state.data = action.payload;
                state.isCompletedLocationCall = true;
            }
        }
    }
})
export default BusinessLocationSlice.reducer;
